export default {
    fake_title: null,
    price: null,
    external_ref: null,
    ad_id: null,
    phone: null,
    ami: null,
    contacts: [],
    photo: null,
    subsidiary_name: null,
    company_name: null,
    subsidiary_ami: null,
    subsidiary_mainphone: null,
    subsidiary_logo: null,
    ad_type: null,
    typeAd: 'ASDASD',
    company_activity: null,
    ad: {
        type: '',
        account: {

            user: {
                id: null,
                photo: null,
                name: null,
            }
        }
    },
    company: {
        company_name: null,
        ami: null,
        company_activity: null,
        logo: null,
        routeSlug: null,
    },
    agentExt: {
        photo: null,
    },
    agentAssociatedUser: {
        photo: null,
    },
    agent_phone: null,
    agent_phone_token: null,
    agent_phone_legislation: '',
    subsidiary_phone_token: null,
    subsidiary_phone_legislation: '',
    agent_name: null,
    showName: true,
    me: {
        senderName: null,
        senderEmail: null,
        senderPhone: null,
    },
    routeSlugAgent: null,
}
